"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      &:before {\n        content: '';\n        display: block;\n        padding-top: ", "%;\n        width: 100%;\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AspectRatio = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _fp = require("lodash/fp");

var _core = require("./core");

var AspectRatio = function AspectRatio(_ref) {
  var x = _ref.x,
      y = _ref.y,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["x", "y", "children"]);
  return _react.default.createElement(_StyledBox, (0, _extends2.default)({
    position: "relative"
  }, props, {
    _css: (0, _fp.divide)(y, x) * 100
  }), _react.default.createElement(_core.Box, {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }, children));
};

exports.AspectRatio = AspectRatio;

var _StyledBox = (0, _styledComponents.default)(_core.Box)(_templateObject(), function (p) {
  return p._css;
});